<template>
    <f7-page id="inbox"
      class="page-on-center rowBackgroundHomepage"
      data-page="inbox-page"
      :pull-to-refresh="isSmartphoneOS">

      <div class="layoutTop"></div>

      <div class="listPage" style="overflow:hidden;">
        <b-row class="form-group justify-content-start showLargeScreenOnly">
          <b-col sm="2">
            <f7-button class="button-action milkyBlockBlack" :disabled="activateSpinner"
              @click="refreshInbox()">
                <f7-icon f7="refresh"></f7-icon>
                <span class="fab-label">{{ $t('common.rfrsh') }}</span>
            </f7-button>
          </b-col>
          <b-col sm="2">
            <f7-button class="button-action milkyBlockBlack"
                href="/businessDocument/OCRScan/">
                <f7-icon f7="add"></f7-icon>
                <span>{{ 'Vérifier' }}</span>
            </f7-button>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12">
            <div class="requestsList">
              <div>
                  <cm-messages-filter
                  class="researchfilter"
                  style="position:relative;z-index:10"
                  isOcr
                  filterType="list"
                  :mode="mode"
                  :randomId="randomId"
                  @applyFilter="applyFilter($event)">
                  </cm-messages-filter>
              </div>
              <div style="margin-top:0">
                <spinner v-if="activateSpinner"></spinner>
                <div v-else style="overflow-x:auto;">
                  <table class="ocrResults">
                    <thead>
                      <th class="text-center" style="width:200px">
                          {{ 'Type de Document' }}
                      </th>
                      <th class="text-center" style="width:200px">
                          {{ 'Date' }}
                      </th>
                      <th class="text-center" style="width:200px">
                          {{ 'Statut' }}
                      </th>
                      <th class="text-center" style="width:400px">
                          {{ 'Nom du document' }}
                      </th>
                      <th class="text-center" style="width:255px">
                          {{ 'Action' }}
                      </th>
                    </thead>
                    <tbody>
                      <template v-if="inboxMessages.length > 0">
                          <tr v-for="(result, index) in inboxMessages" :key="index"
                          class="boxRequest">
                          <td class="text-center" :title="result.type_doc">{{ result.type_doc }}</td>
                          <td class="text-center" :title="dateFormat(result.end_time)">{{ dateFormat(result.end_time) }}</td>
                          <td class="text-center" :title="result.errors" v-if="result.errors">Contient des erreurs</td>
                          <td class="text-center" v-else :title="result.errors">Pas d'erreur</td>
                          <td class="text-center" :title="result.file_name">{{ result.file_name }}</td>
                          <td>
                              <span class="fileClickButton"
                              @click="redirectDetails(result)">
                              {{ $t('common.cnslt') }}
                              </span>
                          </td>
                          </tr>
                      </template>
                      <!-- PAS DE RESULTATS -->
                      <tr v-else>
                          <td colspan="6" class="noResult">
                          {{ $t('common.no_result') }}
                          </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </b-col>
        </b-row>
      </div>
    </f7-page>
</template>

<script>
import moment from 'moment'

import MessagesFilter from '@/components/common/Filter'
import Spinner from '@/components/common/spinner.vue'

import { errorMessageAlert } from '@/helpers/alert'

import { loadPage } from '@/helpers/routing'


export default {
  name: 'VerificationsListPage',
  components: {
    'cm-messages-filter': MessagesFilter,
    'spinner': Spinner
  },
  props: {
    direction: {
      default: '2',
      type: String
    },
    modeFilter: {
      default: '1',
      type: String
    }
  },
  computed: {
    isSmartphoneOS () {
      return this.$f7.device.os === 'android' || this.$f7.device.os === 'ios'
    }
  },
  data () {
    return {
      activateSpinner: false,
      inboxMessages: [],
      mode: 1,
      noMore: false,
      pageCounter: 0,
      paginationObject: {},
      randomId: Math.random().toString(36).substr(2, 10),
      requestsNumber: '',
      scrollFlag: true
    }
  },
  created () {
    this.activateSpinner = true
    this.$engine.ocr.ocrResult({})
    .then(response => {
      console.log(response)
      let requests = []
      requests = response.data.ocrResults
      // that.paginationObject.nbResults = that.requestsNumber
      this.activateSpinner = false

      if (requests.length > 0) {
        for (let i = 0; i < requests.length; i++) {
          that.inboxMessages.push(requests[i])
        }
      }
    })
    .catch(err => {
      console.log(err)
    })
    this.$bus.$emit('change-mobile-header', {
      backLink: false,
      navbarInnerStyle: 'justify-content:start;',
      navTitle: 'Mes scans',
      returnUrl: ''
    })
    this.paginationObject['firstIndex'] = 1
    this.paginationObject['maxResults'] = 13
    this.paginationObject['nbResultsTotal'] = 0
    this.mode = parseInt(this.modeFilter, 10)
    let that = this
    this.$engine.settings.set({msgDirection: this.direction})

    this.$bus.$off('refresh-cache-contacts')

    this.paginationObject['refresh'] = 'direct-inbox-filtered'
    this.$bus.$off('direct-inbox-filtered')
    this.$bus.$on('direct-inbox-filtered', index => {
      // this.onRefresh(false, index)
      that.pageCounter = 0
    })

    this.$f7.initPullToRefresh()
    this.pageCounter = 0
    // this.onRefresh(false)
  },
  mounted () {
    this.$$('.infinite-scroll-preloader').remove()
  },
  beforeDestroy () {
    let that = this
    that.$engine.history.filter.cleanFilterCondition()
  },
  methods: {
    applyFilter (filterConditions) {
      if (filterConditions.modeFilter !== undefined && filterConditions.modeFilter !== this.mode) {
        this.mode = filterConditions.modeFilter
      }

      // this.pageCounter = 0
      // this.paginationObject['firstIndex'] = 1
      // this.paginationObject['nbResultsTotal'] = 0

      this.activateSpinner = true
      this.$engine.ocr.ocrResult(filterConditions)
        .then(response => {
          let requests = []
          requests = response.data.ocrResults
          this.updateInbox(requests)
          this.activateSpinner = false
        })
        .catch(error => {
          errorMessageAlert(error, this, this.$i18n)
        })
    },
    dateFormat (str) {
      return moment(str).format('DD/MM/yyyy HH:mm:ss')
    },
    redirectDetails (result) {
      this.$engine.ocr.selectedResult = result
      loadPage(this, { url: '/businessDocument/list/ocr/detail/' + result.id_file })
      // console.log('first page', result)
    },
    updateInbox (requests, noAttach = false) {
      this.inboxMessages = requests
    }
  }
}
</script>

<style scoped>
.ocrResults {
  border: 1px solid silver;
  border-collapse: separate;
  border-spacing: 0;
  border-radius: 0 0 15px 15px;
  overflow: hidden;
  width: 100%;
}

.ocrResults th {
  background-color: black;
  border: 1px solid silver;
  color: white;
  font-weight: normal;
  height: 40px;
}

.ocrResults tbody tr td {
  border-top: 1px solid silver;
  padding-top: 5px;
  padding-bottom: 5px;
}

.ocrResults tbody tr td,.ocrResults thead th {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// OCRListPage.vue?97a8156a